import { onCLS, onINP, onLCP, type Metric } from 'web-vitals';
import { logger } from '@shared/lib';

/** Field RUM (ARCHITECTURE §6). Swap the sink for a real beacon in production. */
export function reportWebVitals(): void {
  const report = (metric: Metric) =>
    logger.info('web-vital', {
      name: metric.name,
      value: Math.round(metric.value),
      rating: metric.rating,
    });
  onCLS(report);
  onINP(report);
  onLCP(report);
}
